import { Component, EventEmitter, Input, Output, OnInit } from '@angular/core';
import { availableFonts } from '../fonts/fonts';
import { CustomFontsService } from '../fonts/custom-fonts.service';
import { CustomFont } from '../fonts/custom.font';

@Component({
  selector: 'font-family-selector',
  template: `
    <div class="settings-segment-prop">
      <div class="settings-title" translate>COMMON.FONT_FAMILY_SELECTOR.TITLE</div>

      <select class="settings-value"
              name="font-name"
              [(ngModel)]="fontFamily"
              (ngModelChange)="onFontFamilyChanged($event)">
        <option *ngIf="enableNoneOption" [ngValue]="null" translate>COMMON.FONT_FAMILY_SELECTOR.NONE</option>
        <option *ngFor="let fontName of fontNames"
                [ngStyle]="{'font-family': fontName}"
                [value]="fontName">{{ fontName }}
        </option>
        <option class="fonts-title" disabled>Web Fonts</option>
        <option *ngFor="let fontName of webFontsNames"
                [ngStyle]="{'font-family': fontName}"
                [value]="fontName">{{ fontName }}
        </option>
        <option class="fonts-title" disabled>Custom Fonts</option>
        <option *ngFor="let font of customFontsWithFallbackValue"
                [ngStyle]="{'font-family': font.Name}"
                [value]="font.FontFamily">{{ font.Name }}
        </option>
      </select>
    </div>
  `,
  styles: ['option.fonts-title {background-color:#f8f8f8 !important}'],
})
export class FontFamilySelectorComponent {

  @Input() fontFamily: string;
  @Input() enableNoneOption?: boolean = false;
  @Output() fontFamilyChange: EventEmitter<string> = new EventEmitter<string>();

  fontNames: string[] = ['Arial', 'Calibri', 'Comic Sans MS', 'Courier New', 'Georgia', 'Helvetica', 'Lucida Sans Unicode,Lucida Grande', 'Tahoma,Geneva', 'Times New Roman,Times', 'Trebuchet MS', 'Verdana'];
  webFontsNames: string[] = Object.keys(availableFonts);
  customFontsWithFallbackValue: CustomFont[];

  constructor(private customFontsService: CustomFontsService) {
    this.customFontsService.customFonts.subscribe((result) => {
      this.customFontsWithFallbackValue = [];
      result.fonts.forEach(f => {
        const font = {...f};
        font.FontFamily = `${ f.FontFamily },${ f.FallBackFontName }`;
        this.customFontsWithFallbackValue.push(font);
      });
    });
  }

  onFontFamilyChanged($event: string) {
    this.fontFamilyChange.emit($event);
  }
}
